// extracted by mini-css-extract-plugin
export default {"add-result":"add-result___BjPsk"};